<div class="guest-details">
  <div for="" class="page-title guest-details__page-title" *ngIf="ls.operation==operationType.create">
    {{'reservationDetails'| translate}}</div>
  <div for="" class="page-title guest-details__page-title" *ngIf="ls.operation==operationType.edit">
    {{'ModifiedReservationDetails'| translate }}</div>
  <div class="guest-details__reservation-data content-summary" [ngStyle]="{'background-color':ls.restaurantWidgetSettings$.value.WidgetCustomization.SubheaderBackgroundColor,
    'color': ls.restaurantWidgetSettings$.value.WidgetCustomization.SubheaderTextColor}">
    <div style="width: 100%;">
      <span class="guest-details__guest-info-text"
        [ngStyle]="{'border-right-color': ls.restaurantWidgetSettings$.value.WidgetCustomization.SubheaderTextColor}"
        *ngIf="partyDetails?.specialMeal && partyDetails?.specialMeal.Name">{{partyDetails.specialMeal.Name}}
        <span *ngIf="specialMealAmountInfo >0">-
          {{paymentData.OperationCurrency}}{{specialMealAmountInfo | currencyDecimalFormatter}}</span></span>
      <span class="guest-details__guest-info-text"
        [ngStyle]="{'border-right-color': ls.restaurantWidgetSettings$.value.WidgetCustomization.SubheaderTextColor}">
        {{partyDetails?.partySize}} {{'party' | translate}}</span>
      <span class="guest-details__guest-info-text"
        [ngStyle]="{'border-right-color': ls.restaurantWidgetSettings$.value.WidgetCustomization.SubheaderTextColor}">
        <!-- {{partyDetails.reservationTime | date:'MM/dd/yyyy'}}</span> -->
        {{partyDetails.reservationTime | formatSettingsDate: ls.restaurantWidgetSettings$.value.DateFormat}}
      </span>   
      <span class="guest-details__guest-info-text"
        [ngStyle]="{'border-right-color': ls.restaurantWidgetSettings$.value.WidgetCustomization.SubheaderTextColor}">
        {{partyDetails.reservationTime | localizeDate:'h:mm A'}}</span>
      <span class="guest-details__guest-info-text"
        [ngStyle]="{'border-right-color': ls.restaurantWidgetSettings$.value.WidgetCustomization.SubheaderTextColor}"
        *ngIf="canShowSeatingType && partyDetails.seatingType && partyDetails.seatingType.name">{{partyDetails.seatingType.name}}
        <span *ngIf="ratePlanAmountInfo >0">-
          {{paymentData.OperationCurrency}}{{ratePlanAmountInfo | currencyDecimalFormatter}}</span>
      </span>
      <span class="guest-details__guest-info-text"
        [ngStyle]="{'border-right-color': ls.restaurantWidgetSettings$.value.WidgetCustomization.SubheaderTextColor}"
        *ngIf="!(ratePlanAmountInfo >0) && !(specialMealAmountInfo>0) && noShowfee > 0 ">{{ 'amount' | translate}}
        {{paymentData.OperationCurrency}}{{noShowfee | currencyDecimalFormatter}}</span>
        <span class="guest-details__guest-info-text detail-content"
        [ngStyle]="{'border-right-color': ls.restaurantWidgetSettings$.value.WidgetCustomization.SubheaderTextColor}"
        *ngIf="isFormValid && ls.restaurantWidgetSettings$.value.DisableCustomTermsAndConditions && (guestDetailsForm?.value?.primaryGuest?.firstName || guestDetailsForm?.value.primaryGuest?.lastName)">{{guestDetailsForm.value.primaryGuest.firstName}} {{guestDetailsForm.value.primaryGuest.lastName}}</span>
        <span class="guest-details__guest-info-text detail-content"
        [ngStyle]="{'border-right-color': ls.restaurantWidgetSettings$.value.WidgetCustomization.SubheaderTextColor}"
        *ngIf="isFormValid && ls.restaurantWidgetSettings$.value.DisableCustomTermsAndConditions && guestDetailsForm.value.primaryGuest.phone">{{guestDetailsForm.value.primaryGuest.phone}}</span>
        <span class="guest-details__guest-info-text detail-content"
        [ngStyle]="{'border-right-color': ls.restaurantWidgetSettings$.value.WidgetCustomization.SubheaderTextColor}"
        *ngIf="isFormValid && ls.restaurantWidgetSettings$.value.DisableCustomTermsAndConditions && guestDetailsForm.value.primaryGuest.email">{{guestDetailsForm.value.primaryGuest.email}}</span>
    </div>
    <div *ngIf="!ls.restaurantWidgetSettings$.value.DisableCustomTermsAndConditions || !isFormValid" style="padding: 0 12px;">
      <app-button [buttontype]="editButton" (valueChange)="goBackToReservation()"></app-button>
    </div>
    <div *ngIf="isFormValid && ls.restaurantWidgetSettings$.value.DisableCustomTermsAndConditions" class="guest-details__guest-actions">
      <app-button [buttontype]="editSlotsButton" (valueChange)="goBackToReservation()"></app-button>
      <app-button [buttontype]="editGuestButton" (valueChange)="isFormValid = !isFormValid"></app-button>
    </div>
  </div>
  <div class="guest-details__guest-section" [hidden]="ls.restaurantWidgetSettings$.value.DisableCustomTermsAndConditions && isFormValid">
    <!-- <ng-scrollbar> -->
    <!--Needed -->
    <div class="guest-details__admin-msgs"
      *ngIf="this.ls.restaurantWidgetSettings$.value.WidgetCustomization.PreReservationMessage">
      <em class="icon-Info guest-details__info-icon"></em>
      <span *ngIf="isPreReservationMsgHTML"
        [innerHTML]="this.ls.restaurantWidgetSettings$.value.WidgetCustomization.PreReservationMessage"></span>
      <span
        *ngIf="!isPreReservationMsgHTML">{{this.ls.restaurantWidgetSettings$.value.WidgetCustomization.PreReservationMessage}}</span>
    </div>
    <div class="guest-details__guest-data">
      <div class="guest-details__remaining-time-indicator" *ngIf="ls.showTimer">
        <div class="focused-sub-header"
          [ngStyle]="{'color':ls.restaurantWidgetSettings$.value.WidgetCustomization.WidgetLinkColor}">{{ls.minutes}}
          <span class="error-message">{{'mins' | translate}}</span> {{ls.seconds}} <span class="error-message">{{'secs'
            | translate}}</span></div>
        <div class="default-form-field guest-details__time-left-text">{{'leftForBooking' | translate}}</div>
      </div>
      <div class="guest-details__guest-info" *ngFor="let guest of guestData;let i=index;trackBy:trackByGuest"
        [ngStyle]="{'background-color':ls.restaurantWidgetSettings$.value.WidgetCustomization.MaincontentBottomBackgroundColor}">
        <div for="" class="section-header guest-details__guest-title">{{guest | translate}}
          <em *ngIf="ls.operation == operationType.edit && i!=0" class="icon-DeleteWidget guest-details__delete-icon"
            (click)="openDeleteConfirmationPopUp(i)"></em>
        </div>
        <div class="rs-pt-15"
          *ngIf="ls.operation != operationType.edit || (ls.operation == operationType.edit && i == 0)">
          <dynamic-form [config]="guestInfoConfig" #form="dynamicForm">
          </dynamic-form>
        </div>
        <div *ngIf="ls.operation == operationType.edit && i != 0">
          <dynamic-form [config]="guestInfoConfigSecondary" #form="dynamicForm">
          </dynamic-form>
        </div>
        <!-- <span class="guest-details__data-retention" *ngIf="dataRetentionPolicyExisting"  (click)="showDataRententionPolicy()">{{'clickhere' | translate}}</span> -->
      </div>
      <div style="display: flex;flex-direction: column;" *ngIf="noShowfee >0 && !rs.additionalGuestPage">
        <span class="default-sub-header" style="padding-bottom: 8px;margin-top: 16px;">{{noShowPolicyTitle}}</span>
        <div class="default-form-field mb-0" style="background: #f7f7f7;padding: 15px;border-radius: 4px;width: auto;">
          <span>{{'noShowCancellationFee' | translate}} : {{paymentData.OperationCurrency}}{{noShowfee | currencyDecimalFormatter}}</span>
          <p style="padding-top: 8px;margin-bottom: 0;">{{noShowfeeMessage}}</p>
        </div>
      </div>
      <div style="display: flex;flex-direction: column;"
        *ngIf="activityPayment>0 && !rs.additionalGuestPage && ls.operation==operationType.create">
        <span class="default-sub-header" style="
              padding: 10px;margin-top: 16px;
          ">{{'prePaymentPolicy' | translate}}</span>

        <div class="default-form-field mb-0" *ngIf="!this.paymentData.TaxAmount" style="    background: #f7f7f7;
              padding: 15px;
              border-radius: 4px;width: auto;">
          <span>{{'payment' | translate}} : {{paymentData.OperationCurrency}}{{activityPayment}}</span>
          <p class="" style="    padding-top: 8px;
              margin-bottom: 0;">
            {{paymentMessage}}
          </p>
        </div>
        <div class="payment-with-tax-view" *ngIf="this.paymentData.TaxAmount">
          <div class="payment-tax-view-section default-form-field mb-0">
            <span>{{'SubTotal' | translate}} :</span>
              <span>{{paymentData.OperationCurrency}}{{paymentWithoutTax | currencyDecimalFormatter}}</span>            
          </div>
          <div class="payment-tax-view-section default-form-field mb-0">
            <span>{{'taxAmount' | translate}} :</span>
              <span> {{paymentData.OperationCurrency}}{{this.paymentData.TaxAmount | currencyDecimalFormatter}}</span>           
          </div>
          <div class="payment-tax-view-section default-form-field mb-0">
            <span>{{'serviceCharges' | translate}} :</span>
              <span> {{paymentData.OperationCurrency}}{{this.serviceCharge | currencyDecimalFormatter}}</span>           
          </div>
          <div class="payment-tax-view-section default-form-field mb-0">
            <span>{{'taxOnserviceCharge' | translate}} :</span>
              <span> {{paymentData.OperationCurrency}}{{this.taxOnServiceCharge | currencyDecimalFormatter}}</span>           
          </div>
          <div class="payment-tax-view-section default-form-field mb-0 mt-1 pt-1 border-top">
            <span>{{'grandTotal' | translate}} :</span>
              <span> {{paymentData.OperationCurrency}}{{activityPayment | currencyDecimalFormatter}}</span>
          </div>
          <p class="" style="    padding-top: 8px;
          margin-bottom: 0;    ">
        {{paymentMessage}}
      </p>
        </div>
        
      </div>
    </div>
    <div class="guest-details__validation">
      <div class="guest-details__validation-info" *ngIf="ls.restaurantWidgetSettings$.value.DisableCustomTermsAndConditions">
        <span *ngIf="validationMessageList?.length" class="guest-details__validation-info__text" [innerHTML]="validationMessageList[0]"></span>
        <ul *ngIf="validationMessageList?.length > 1" class="ps-5">
          <li *ngFor="let validationMessage of validationMessageList | slice : 1; let i = index" class="guest-details__validation-info__text" [innerHTML]="validationMessage"></li>
        </ul>
      </div>
      <div>
        <app-button
        *ngIf="ls.restaurantWidgetSettings$.value.DisableCustomTermsAndConditions && showIframe"
        [buttontype]="nextButton" (valueChange)="enableIframe()"></app-button>
      </div>
    </div>
    <div class="rs-ps-10">
      <app-button
        *ngIf="((rs.additionalGuestPage && (rs.additionalGuestRequired) > guestData.length)|| (ls.operation == operationType.edit && (partyDetails.partySize > guestData.length))) && ls.restaurantWidgetSettings$.value.WidgetCustomization.AllowAdditionalGuestDetails"
        [buttontype]="additionalGuestBtn" (valueChange)="additionalGuest()"></app-button>
    </div>
    <div class="guest-details__actions" *ngIf="!confirmButton.disbaledproperity || !showIframe">
      <app-button [buttontype]="previousButton" (valueChange)="getSeatSelection()"></app-button>
      <app-button [buttontype]="confirmButton" (valueChange)="reservationConfirm()"></app-button>
    </div>

    <!-- </ng-scrollbar> -->
  </div>
  <div *ngIf="urlSafe" class="guest-details__iframe-view" [hidden]="!(showIframe && isFormValid)">
    <iframe class="responsive-iframe" frameBorder="0" [src]="urlSafe"></iframe>
    <div *ngIf="guestDetailsForm.invalid"
        class="px-5 position-absolute activity-description-bold payment-protection d-flex flex-column justify-content-center">
        <div class="p-3 d-flex justify-content-center payment-overlay-text align-items-center text-center">
          {{ "enterNecessaryDetailsForPayment" | translate }}
        </div>
      </div>
  </div>
</div>